import { useMemo, useState } from 'react'

import { useRecord } from '@/shared/hooks'
import { useNavigation } from '@/shared/hooks/useNavigation'
import { LevelPlayFinish } from '@/shared/level-play'
import { Button } from '@/shared/ui/Button'

import { useLevelContext } from '../context'

/**
 * Conclusão do nível — wrapper de domínio sobre `LevelPlayFinish`.
 *
 * O que é da jornada e por isso fica aqui: de onde vêm o percentual, as
 * recompensas e a lista de desafios, e para onde o participante vai depois.
 */
export const DigitalProductJourneyLevelFinish = () => {
  const { navigateTo } = useNavigation()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const {
    level,
    journey,
    journeyAllowWrongAnswers,
    config: { apiBasePath }
  } = useLevelContext()

  const { record: nextLevel } = useRecord({
    r: apiBasePath,
    id: level.uid,
    action: 'next'
  })

  const items = useMemo(
    () =>
      (level?._challenges ?? []).map(challenge => ({
        id: challenge.uid,
        name: challenge.name,
        correct: !!challenge._progress?.correctAnswer
      })),
    [level?._challenges]
  )

  const handleNextLevel = () => {
    setIsRedirecting(true)
    navigateTo(`/jornadas/${journey?.uid}/niveis/${nextLevel?.uid}/iniciar`)
  }

  return (
    <LevelPlayFinish
      correctPercent={level?._correctPercent ?? 0}
      rewards={level?._progress?.rewards}
      showBreakdown={journeyAllowWrongAnswers}
      items={items}
      actions={
        <div className="flex flex-col md:flex-row gap-4 justify-around w-full">
          {!isRedirecting && (
            <Button
              variant="ghost"
              href={`/jornadas/${journey?.uid}`}
              className="grow"
            >
              Voltar para a jornada
            </Button>
          )}
          {nextLevel && (
            <Button
              variant="primary"
              size="md"
              className="grow"
              loading={isRedirecting}
              onClick={handleNextLevel}
              disabled={isRedirecting}
            >
              {isRedirecting ? 'Carregando próximo nível' : 'Próximo nível'}
            </Button>
          )}
        </div>
      }
    />
  )
}
